import { useEffect, useState } from 'react';

import type { ProfAI } from '../agents/profai';

/**
 * To bridge the stateful coach with the reactive UI
 */
export function useLessonScreen<Coach extends ProfAI>(coach?: Coach) {
  const [screen, setScreen] = useState(coach?.getTool());
  useEffect(() => {
    if (!coach) return;
    coach.subscribe(setScreen);
    return () => coach.unsubscribe(setScreen);
  }, [coach]);
  return screen;
}
